import { render, staticRenderFns } from "./Fluxo.vue?vue&type=template&id=de441574"
import script from "./Fluxo.vue?vue&type=script&lang=js"
export * from "./Fluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports